import React from 'react';
import { Link } from 'react-router-dom';
import MainNav from './MainNav';

import logo from '../logo.svg';
import logoAlt from '../logo-inverted.svg';

import './Header.css';

const Header = (props) => {
  if(props.type === "simple") {
  	return (
      <header className="App__header App__header--no-bg row expanded collapse">
    		<div className="small-12 columns">
    			<h1 className="App__header-title"><Link to='/'><img src={logoAlt} className="App-logo" alt="logo" /> Rob Lee</Link></h1>
    			<MainNav />
        </div>
    	</header>
    )
  } else {
    return (
      <header className="App__header row expanded collapse">
        <div className="small-12 columns">
          <h1 className="App__header-title"><Link to='/'><img src={logo} className="App-logo" alt="logo" /> Rob Lee</Link></h1>
          <MainNav />
        </div>
      </header>
    )
  }
}

Header.propTypes = {  
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js